import MediaInsertUI from "./MediaInsertUI";
import MediaInsertEditing from "./MediaInsertEditing";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class MediaInsert extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "MediaInsert";
  }

  static get requires() {
    return [MediaInsertUI, MediaInsertEditing];
  }
}
